import { createFileRoute, redirect } from '@tanstack/react-router';

import { ChangeToE2EPage } from '@frontend/features/auth/components/ChangeToE2EPage';
import { isProduction } from '@frontend/features/auth/util/util.auth.isProduction';

export const Route = createFileRoute('/change-to-e2e/')({
  component: ChangeToE2EPage,
  beforeLoad: () => {
    // Block on production
    if (isProduction()) {
      throw redirect({
        to: '/',
      });
    }
  },
});
